<template>
  <div class="vuestic-tree-category">
    <div class="vuestic-tree-category__header">
      <div class="vuestic-tree-category__header-icon"
           v-if="$slots.icon"
      >
        <slot name="icon"/>
      </div>
      <div class="vuestic-tree-category__header-label" v-if="label.length < 2">
        <span v-if="(Array.isArray(data.service_id) && data.service_id[0]) || data.service_id">
          <router-link :to="{ name: data.service_type, params: { id: Array.isArray(data.service_id) ? data.service_id[0] : data.service_id }}">
            {{ label[0] }}
            <span :class="selectColor(data.service_type)" v-if="!data.parent"></span>
          </router-link>
        </span>
        <span v-else>
          {{ label[0] }}
          <span v-if="link">
            <router-link :to="{ name: link, params: { id: 'add' } }">
              <img src="static/icons/actions/add-32.png" style="cursor: pointer; height: 1.25em; margin-left: 0.1em;" />
            </router-link>
          </span>
          <span :class="selectColor(data.service_type)" v-else></span>
        </span>
      </div>
      <div class="vuestic-tree-category__header-label" v-else>
        <span v-if="toggle" v-on:click="toggle = false" class="expand">...</span>
        <span v-else>
          <span v-if="(Array.isArray(data.service_id) && data.service_id[0]) || data.service_id">
            <router-link :to="{ name: data.service_type, params: { id: Array.isArray(data.service_id) ? data.service_id[0] : data.service_id }}">
              {{ label[0] }}
            </router-link>
          </span>
          <span v-else>
            {{ label[0] }}
          </span>
          <span v-on:click="toggle = true" class="expand">...</span>
        </span>
        <span v-for="(name, i) in label" v-if="toggle">
          <br />
          <span v-if="data.service_id[i]">
            <router-link :to="{ name: data.service_type, params: { id: data.service_id[i] }}">
              {{ name }}
            </router-link>
          </span>
          <span v-else>
            {{ name }}
          </span>
        </span>
      </div>
      <span class="text-bottom-class" v-if="data && data.type === 'destination' && data.children && data.children.length > 0">&nbsp;--->&nbsp;
        <span v-if="data.children[0].service_id">
          <router-link :to="{ name: data.children[0].service_type, params: { id: data.children[0].service_id }}">
            {{ data.children[0].name }}
          </router-link>
          <span :class="selectColor(data.children[0].service_type)"></span>
        </span>
        <span v-else>
          {{ data.children[0].name }}
          <span :class="selectColor(data.children[0].service_type)"></span>
        </span>
      </span>
      <span class="text-bottom-class" v-if="data && data.type === 'destination'">
        <div class="vuestic-tree-category__header-checkbox" @click="isOpenCached = ! isOpenCached" v-if="data && data.children && data.children.length > 0 && data.children[0].children && data.children[0].children.length > 0">
          <square-with-icon :iconClass="checkboxIconClass"/>
        </div>
      </span>
      <span class="text-bottom-class" v-else>
        <div class="vuestic-tree-category__header-checkbox" @click="isOpenCached = ! isOpenCached" v-if="data && data.children && data.children.length > 0">
          <square-with-icon :iconClass="checkboxIconClass"/>
        </div>
      </span>
    </div>

    <div class="vuestic-tree-category__list-container" v-if="isOpenCached">
      <div class="vuestic-tree-category__list-internal-container">
        <slot></slot>
      </div>
    </div>

  </div>
</template>

<script>
  import SquareWithIcon from './vuestic-div-checkbox/SquareWithIcon.vue'
  import VuesticCheckbox from '../vuestic-checkbox/VuesticCheckbox'

  export default {
    name: 'vuestic-tree-category',
    components: { SquareWithIcon, VuesticCheckbox },
    data () {
      return {
        isOpenCached: false,
        toggle: false
      }
    },
    watch: {
      isOpen: {
        handler (isOpen) {
          this.isOpenCached = isOpen
        },
        immediate: true,
      },
    },
    props: {
      label: {
        type: [String, Number, Array],
        default: '',
      },
      isOpen: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Object,
      },
      link: {
        type: String
      }
    },
    computed: {
      checkboxIconClass () {
        return this.isOpenCached ? 'mdi mdi-arrow-collapse' : 'mdi mdi-arrow-expand'
      },
    },
    methods: {
      /**
       * @public
       */
      collapse () {
        this.isOpenCached = false
        this.$nextTick(() => {
          this.$children.forEach(child => {
            if (child.$options.name === 'vuestic-tree-category') {
              child.collapse()
            }
          })
        })
      },
      collapseToggle () {
        this.toggle = false
      },
      /**
       * @public
       */
      expand () {
        this.isOpenCached = true
        this.$nextTick(() => {
          this.$children.forEach(child => {
            if (child.$options.name === 'vuestic-tree-category') {
              child.expand()
            }
          })
        })
      },
      expandToggle () {
        this.toggle = true
      },
      expandDefault () {
        this.isOpenCached = true
      },
      selectColor (type) {
        switch (type) {
          case 'Fonenumber':
            return 'dot-pink'
          case 'Device':
            return 'dot-indigo'
          case 'SpeedDial':
            return 'dot-dpurple'
          case 'User':
            return 'dot-dgreen'
          case 'Announcement':
            return 'dot-purple'
          case 'DigitQuery':
            return 'dot-blue'
          case 'IVRMenu':
            return 'dot-lime'
          case 'RingGroup':
            return 'dot-orange'
          case 'Scheduler':
            return 'dot-brown'
          case 'Voicemail':
            return 'dot-bgrey'
          default:
            return 'dot-grey'
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";

  .vuestic-tree-category {
    &__header {
      display: flex;
    }
    &__header-checkbox {
      cursor: pointer;
      margin-left: 0.75rem;
    }
    &__header-icon {
      cursor: text !important;
      margin-right: 0.375rem;
    }
    &__header-label {
      word-wrap: break-word;
      overflow: hidden;
    }
    &__list-container {
      margin-top: 0.625rem;
      margin-bottom: 0.625rem;
      padding-left: 0.6875rem;
    }
    &__list-internal-container {
      border-left: dashed 0.0625rem $lighter-gray;
      padding-left: 2.5rem;
    }
    // List items require padding. Somewhat hacky, but the only remaining option is using render functions.
    .vuestic-tree-category + .vuestic-tree-category, .vuestic-tree-node + .vuestic-tree-node, .vuestic-tree-category + .vuestic-tree-node, .vuestic-tree-node + .vuestic-tree-category {
      margin-top: 0.625rem;
    }
  }

  .expand:hover {
    cursor: pointer;
    text-decoration: underline;
    color: $fractel-teal;
  }

  .text-bottom-class {
    display: flex;
    align-items: end;
    justify-content: end;
  }

  .dot-pink {
    height: 10px;
    width: 10px;
    background-color: #E91E63;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-indigo {
    height: 10px;
    width: 10px;
    background-color: #3F51B5;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-dpurple {
    height: 10px;
    width: 10px;
    background-color: #673AB7;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-dgreen {
    height: 10px;
    width: 10px;
    background-color: #356800;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-purple {
    height: 10px;
    width: 10px;
    background-color: #9C27B0;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-blue {
    height: 10px;
    width: 10px;
    background-color: #2196F3;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-lime {
    height: 10px;
    width: 10px;
    background-color: #CDDC39;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-orange {
    height: 10px;
    width: 10px;
    background-color: #FF9800;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-brown {
    height: 10px;
    width: 10px;
    background-color: #795548;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-grey {
    height: 10px;
    width: 10px;
    background-color: #9E9E9E;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-bgrey {
    height: 10px;
    width: 10px;
    background-color: #607D8B;
    border-radius: 50%;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeCategory.vue